var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.product)?_c('div',[_c('Header'),_c('MainNav'),_c('ProductTitle',{attrs:{"productName":_vm.product.name}}),_c('ProductDescription',{attrs:{"product":_vm.product}}),_c('ProductProperties',{attrs:{"product":_vm.product}}),_c('ProductLabel',{attrs:{"product":_vm.product}}),_c('Footer')],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }